export default function (appointmentstatus, time) {
  const canRescheduleWithoutConditions = ['Scheduled'];
  if (canRescheduleWithoutConditions.includes(appointmentstatus)) return true;
  // Making sure DrSmile doesn't add another condition without our knowledge we check if it's different of 'No show'
  if (appointmentstatus !== 'No show') return;
  const today = new Date();
  const appointmentDate = new Date(time);
  const DAYS_FOR_RESCHEDULING = 14;
  const timeForRescheduling =
    today - new Date(today.getFullYear(), today.getMonth(), today.getDate() - DAYS_FOR_RESCHEDULING);
  const timeSinceAppointment = today - appointmentDate;
  return timeForRescheduling > timeSinceAppointment;
}
